module.exports = __webpack_public_path__ + "media/sonia.b5ba29fc.mp3";